import Backbone from 'backbone'
import _ from 'lodash'

/**
 * Used to add allow the extension definition of cloneDeep to be available
 * immediately when another module imports setup-backbone.js
 * Currently, this is primarily needed whenning running unit tests
 * @returns {Backbone.Model}
 */
Backbone.Model.prototype.cloneDeep = function() {
	return new this.constructor(_.cloneDeep(this.attributes))
}